import { escapeRegExp } from "./escapeRegExp"

export const removeSeparators = (value, separator = ",") => {
  const reg = new RegExp(escapeRegExp(separator), "g")
  return value.replace(reg, "")
}
